import { FC } from 'react';

import { Box, Divider, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { Element } from 'react-scroll';

import ResultPanelEmptyData from '@components/store/data-display/resultPanel/resultPanelEmptyData';
import ProductInstructorInfo from '@components/store/product/productInstructor/productInstructorInfo';
import { CourseInstructorEntity } from '@redux/course/type/courseDetailType';

type ProductInstructorProps = {
  scrollElementName: string;
  instructors: CourseInstructorEntity[];
};

const ProductInstructor: FC<ProductInstructorProps> = ({ scrollElementName, instructors = [] }) => {
  const { t } = useTranslation('store_course');

  return (
    <Element name={scrollElementName}>
      <Typography variant="h4" mb={1}>
        {t('course_detail.course_instructor.title')}
      </Typography>
      <Divider />

      <Box>
        {instructors.length > 0 ? (
          instructors.map((instructor, index) => (
            <ProductInstructorInfo
              key={instructor.slug}
              instructor={instructor}
              isUnderline={instructors.length !== index + 1}
            />
          ))
        ) : (
          <ResultPanelEmptyData sx={{ height: 264, mt: 3 }} />
        )}
      </Box>
    </Element>
  );
};

export default ProductInstructor;
